import { gql } from "@apollo/client"

export const TOURNAMENT_STANDING = gql`
  query TournamentStanding($TournamentStandingInput: TournamentStandingInput!) {
    TournamentStanding(input: $TournamentStandingInput) {
      status {
        success
        name
        detail
      }
      Standing {
        id
        playerId
        position
        points
        omw
        pgw
        ogw
        TournamentPlayer {
          id
          drop
          raceId
          Person {
            id
            avatar
            fullName
            urlAvatar
            code
          }
        }
      }
    }
  }
`
